// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3nTem","info":"Note_info__emHg-","note":"Note_note__1YdCY","actions":"Note_actions__2Wz5h"};